import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '../styles';
export const VerticalListArrow = (props) => {
    const { onClick, direction, visible, classObject, className } = props;
    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: Colors.White,
            opacity: visible ? 0.8 : 0,
            height: '100%',
            cursor: 'pointer',
            transition: 'all .3s ease',
            width: 40,
            position: 'absolute',
            top: 0,
            bottom: 0,
            ':hover': {
                width: 48,
                opacity: 1,
            },
        },
        positionRight: {
            right: 0,
            [MediaBreakPointUp.XL]: {
                right: -2, // PCで少しズレてるように見えるので2px調整
            },
        },
        positionLeft: {
            left: 0,
            [MediaBreakPointUp.XL]: {
                left: -2, // PCで少しズレてるように見えるので2px調整
            },
        },
        icon: {
            userSelect: 'none',
            width: `100%`,
        },
    });
    const iconURL = direction === 'prev' ? '/assets/images/icons/left_arrow.svg' : '/assets/images/icons/right_arrow.svg';
    const position = direction === 'prev' ? styles.positionLeft : styles.positionRight;
    return (React.createElement("div", { className: css(styles.container, position, classObject) + ` ${className}`, onClick: onClick },
        React.createElement("img", { src: iconURL, className: css(styles.icon) })));
};
